var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86001 2.57323L1.21335 11.9999C1.09693 12.2015 1.03533 12.4301 1.03467 12.6629C1.03402 12.8957 1.09434 13.1246 1.20963 13.3269C1.32492 13.5292 1.49116 13.6977 1.69182 13.8158C1.89247 13.9339 2.12055 13.9973 2.35335 13.9999H13.6467C13.8795 13.9973 14.1076 13.9339 14.3082 13.8158C14.5089 13.6977 14.6751 13.5292 14.7904 13.3269C14.9057 13.1246 14.966 12.8957 14.9654 12.6629C14.9647 12.4301 14.9031 12.2015 14.7867 11.9999L9.14001 2.57323C9.02117 2.3773 8.85383 2.21531 8.65414 2.10288C8.45446 1.99046 8.22917 1.9314 8.00001 1.9314C7.77086 1.9314 7.54557 1.99046 7.34588 2.10288C7.1462 2.21531 6.97886 2.3773 6.86001 2.57323Z",
    fill: "#DA4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8.66667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3333H8.00444",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRed);
export default __webpack_public_path__ + "static/media/alert-red.97ff759e9b6a5d22f5eb45215bcffbd2.svg";
export { ForwardRef as ReactComponent };